import { HttpInterceptorFn } from "@angular/common/http";
import { environment } from "@env/environment";
import { BYPASS_AUTH } from "../../../constants";

export const correlationInterceptor: HttpInterceptorFn = (req, next) => {
  const isInternalApi = isInternalApiRequest(req.url);

  if (!isInternalApi || BYPASS_AUTH) {
    return next(req);
  }

  const correlationId = generateCorrelationId();

  const headers: Record<string, string> = {
    "x-correlation-id": correlationId,
    "x-requested-by": "horus-web",
  };

  const correlationReq = req.clone({
    withCredentials: true,
    setHeaders: headers,
  });

  return next(correlationReq);
};

function isInternalApiRequest(url: string): boolean {
  return url.startsWith(environment.BASE_API);
}

function generateCorrelationId(): string {
  return `corr-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
}
